import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66c4b29a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "list" };
const _hoisted_2 = { class: "subject" };
const _hoisted_3 = { class: "describe" };
import { ref } from 'vue';
import Select from '@/materials/atoms/Select.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        initZone: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const { format, USER_SETTINGS_MESSAGES } = useMessage();
        const list = [
            { title: 'Etc/UTC', value: 'Etc/UTC' },
            { title: 'Asia/Tokyo', value: 'Asia/Tokyo' },
            { title: 'Asia/Shanghai', value: 'Asia/Shanghai' },
            { title: 'Asia/Singapore', value: 'Asia/Singapore' },
            { title: 'Asia/Dubai', value: 'Asia/Dubai' },
            { title: 'America/New_York', value: 'America/New_York' },
        ];
        const timeZone = ref(props.initZone);
        const onChange = (value) => {
            emit('change', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(USER_SETTINGS_MESSAGES).TIME_ZONE)), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(Select, {
                        selectionList: list,
                        model: timeZone.value,
                        width: 180,
                        onChange: onChange
                    }, null, 8, ["model"])
                ])
            ]));
        };
    }
});
